<template>
  <div class="aboutpage4">
    <div class="page4List w-main">
      <div class="item" v-for="(item, index) in dataArr" :key="index">
        <div class="itemimg">
          <el-image :src="item.cover" fit="fill"></el-image>
        </div>
        <div class="itemTitle">{{ item.position }}</div>
        <div class="itemName">
          {{ item.name }}
          <span>{{ item.companyPosition }}</span>
        </div>
        <div class="itemText" :title="item.company">{{ item.company }}</div>
      </div>
    </div>
    <el-pagination
      background
      layout="prev, pager, next"
      :total="pags.total"
      :page-size.sync="pags.pageSize"
      class="pageBox"
      @current-change="changePage"
    ></el-pagination>
  </div>
</template>

<script>
import { getCouncilMember } from "@/api/api.js";

export default {
  data() {
    return {
      pags: {
        pageNum: 1,
        pageSize: 15,
        total: 1
      },
      dataArr: []
    };
  },
  mounted() {
    this.getCouncilMember();
  },
  methods: {
    getCouncilMember() {
      getCouncilMember(this.pags).then(res => {
        if (res.code === 0) {
          this.dataArr = res.data.list;
          this.pags.total = res.data.total;
        } else {
          this.$message({
            message: res.msg,
            type: "error"
          });
        }
      });
    },
    changePage(val) {
      this.pags.pageNum = val;
      this.getCouncilMember();
    }
  }
};
</script>

<style lang="less">
.aboutpage4 {
  .page4List {
    display: flex;
    flex-wrap: wrap;
    // justify-content: space-between;
    .item {
      width: 210px;
      margin: 0 37px 30px 0;
      .itemimg {
        margin-bottom: 14px;
        width: 100%;
        height: 240px;
        background: rgba(220, 220, 220, 1);
      }
      .itemTitle {
        margin-bottom: 10px;
        font-size: 20px;
        font-weight: bold;
        color: rgba(52, 52, 52, 1);
      }
      .itemName {
        margin-bottom: 6px;
        font-size: 18px;
        font-weight: bold;
        color: rgba(52, 52, 52, 1);
        span {
          margin-left: 6px;
          font-size: 14px;
          font-weight: 400;
        }
      }
      .itemText {
        width: 100%;
        height: 40px;
        line-height: 20px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        margin-bottom: 4px;
        font-size: 14px;
        color: rgba(52, 52, 52, 1);
      }
    }
    .item:nth-child(5n) {
      margin: 0 0px 30px 0;
    }
  }
  .pageBox {
    text-align: center;
    margin: 50px auto 0;
  }
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #0f4581;
  }
}
</style>
